import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../styled/theme';
import { Container, Flex, Chip } from '../styled/BaseComponents';

const FooterWrapper = styled.footer`
  text-align: center;
  border-top: 1px solid ${theme.colors.border};
  padding: 20px 0;
  opacity: 0.8;
  color: ${theme.colors.text};
  margin-top: 1.5rem;
`;

const FooterLinks = styled(Flex)`
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
`;

const ChipLink = styled(Chip)`
  color: ${theme.colors.accent2};
  border:none;
`;

export const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <FooterLinks gap="0.75rem">
          <Link to="/privacy">
            <ChipLink>Privacy</ChipLink>
          </Link>
          <Link to="/about">
            <ChipLink>About us</ChipLink>
          </Link>
          <Link to="/download">
            <ChipLink>Download</ChipLink>
          </Link>
          <Link to="/">
            <ChipLink>Home</ChipLink>
          </Link>
        </FooterLinks>
        <div style={{ color: 'var(--custodiy-text)' }}>
          ©️ {String(new Date().getFullYear())} Custodiy Financial Services Ltd — All rights reserved.
        </div>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;

